import React, { useEffect } from 'react';
import Button from "@mui/material/Button";
import CircularProgress from '@mui/material/CircularProgress';
import Grid from "@mui/material/Grid";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
// import CameraComponent from './CameraComponentV2';
// import RegisterComponent from './RegisterComponent';
// import WellcomeComponent from './WellcomeComponent';
 
import { GetInspectionCase } from './API';


// console.log(window.location)
const windowUrl = window.location.search;
// console.log(windowUrl)
const params = new URLSearchParams(windowUrl);
// console.log(params)

// const ref_no = params.get('_r')
// console.log(ref_no) // BOD202209-12603

const encodedrNO = params.get('_r')
// console.log(encodedrNO) // Qk9EMjAyMjA5LTEyNjAz
  // // Decode the String
  var ref_no = atob(encodedrNO);
  // console.log(ref_no); // Outputs: ABB202209-13007

const encodedcID = params.get('_c')
// console.log(encodedcID) // Qk9EMjAyMjA5LTEyNjAz
  // // Decode the String
  var caseID = atob(encodedcID);
  // console.log(caseID); // Outputs: 138

const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;
let loadingSize = 40;
    if(windowWidth > windowHeight){ 
        loadingSize = windowHeight*0.75; 
    } else{ 
        loadingSize = windowWidth*0.75; 
    }

function App() {
    const [loading, setLoading] = React.useState(false);
    const [caseData, setCaseData] = React.useState(false);


    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
      console.log("getData", ref_no , caseID);
      if(ref_no && caseID){
        console.log("getData if");
            let qString = '?rNo='+ref_no+'&cID='+caseID;
            setLoading(true);
            GetInspectionCase(qString).then(response => {
                if (response && response.status === 200) {
                    setAllDataStep(response.data);
                    setLoading(false);
                }else if (response && response.data){
                    console.log("API response error ["+ response.status + "]", response.data.message);
                }else{
                    console.log("API response error", response);
                }
            })
      }else{
        console.log("getData else");
        alert("parameter ไม่ถูกต้อง");
        return;
      }
    }

    const setAllDataStep = (data) => {
      console.log("set data", data);
      let caseData = [];
      if(data.notify){
        let notify = data.notify[0];
        caseData.plate_no = notify.plate_no;
        caseData.plate_province_desc = notify.plate_province_desc;
        caseData.car_brand = notify.car_brand;
        caseData.car_model = notify.car_model;
        caseData.car_color = notify.car_color;
        caseData.chassis_no = notify.chassis_no;
        caseData.engine_no = notify.engine_no;
      }
      if(data.damagePart_memo){
        caseData.damage_detail = data.damagePart_memo;
      }
      if(data.accessory){
        let accessoryData = data.accessory;
        accessoryData?.forEach((value, index) => {
          // console.log("value.partname",value.partname);
          if(value.partname == "ยางอะไหล่"){
            caseData.spareTireIsExist = value.image.length > 0 ? "มี":"ไม่มี";
          }else
          if(value.partname == "กล้องหน้ารถยนต์"){
            caseData.carCAMIsExist = value.image.length > 0 ? "มี":"ไม่มี";
          }else
          if(value.partname == "ล้อแม็ก"){  // ล้อแม็ก เป็นติ๊กว่ามี/ไม่มี ไม่ต้องอัพรูป จึงเช็คที่ ava แทน
            // caseData.maxWheelIsExist = value.image.length > 0 ? "มี":"ไม่มี";
            caseData.maxWheelIsExist = value.available == 1 ? "มี":"ไม่มี";
          }else{
          }
        });
      }
      if(data.document){
        let documentData = data.document;
        documentData?.forEach((value, index) => {
          // console.log("value.partname",value.partname);
          if(value.document == "เล่มทะเบียนรถ"){
            caseData.carBookIsExist = value.image.length > 0 ? "มี":"ไม่มี";
          }else
          if(value.document == "เลขตัวถัง"){
            caseData.carChassisIsExist = value.image.length > 0 ? "มี":"ไม่มี";
          }else{
          }
        });
      }
      console.log("caseData", caseData);

      setCaseData(caseData);
    }

  return (
    <div style={{maxWidth:'900px',margin:'0 auto',padding:'4vh 4vw'}}>
      {
        loading ? <div style={{display: 'flex', justifyContent: 'center'}}>
          <CircularProgress size={loadingSize} style={{margin:'0 auto'}} />
        </div>
        :
        <React.Fragment>
          <h3>สรุปผลการตรวจสภาพรถด้วยตนเอง</h3>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}><h4>ข้อมูลรถ</h4></Grid>

                <Grid item xs={3} sm={3}><FormLabel >ทะเบียนรถ</FormLabel></Grid>
                <Grid item xs={3} sm={3}>
                    <FormLabel >{caseData?.plate_no?caseData.plate_no:"-"}</FormLabel>
                </Grid>
                <Grid item xs={3} sm={3}><FormLabel >จังหวัด</FormLabel></Grid>
                <Grid item xs={3} sm={3}>
                    <FormLabel >{caseData?.plate_province_desc?caseData.plate_province_desc:"-"}</FormLabel>
                </Grid>

                <Grid item xs={3} sm={3}><FormLabel >ยี่ห้อรถ</FormLabel></Grid>
                <Grid item xs={3} sm={3}>
                    <FormLabel >{caseData?.car_brand?caseData.car_brand:"-"}</FormLabel>
                </Grid>
                <Grid item xs={3} sm={3}><FormLabel >รุ่นรถ</FormLabel></Grid>
                <Grid item xs={3} sm={3}>
                    <FormLabel >{caseData?.car_model?caseData.car_model:"-"}</FormLabel>
                </Grid>

                <Grid item xs={3} sm={3}><FormLabel >สี</FormLabel></Grid>
                <Grid item xs={3} sm={9}>
                    <FormLabel >{caseData?.car_color?caseData.car_color:"-"}</FormLabel>
                </Grid>

                <Grid item xs={3} sm={3}><FormLabel >เลขตัวถัง</FormLabel></Grid>
                <Grid item xs={3} sm={9}>
                    <FormLabel >{caseData?.chassis_no?caseData.chassis_no:"-"}</FormLabel>
                </Grid>

                <Grid item xs={3} sm={3}><FormLabel >เลขเครื่องยนต์</FormLabel></Grid>
                <Grid item xs={3} sm={9}>
                    <FormLabel >{caseData?.engine_no?caseData.engine_no:"-"}</FormLabel>
                </Grid>
                

              <Grid item xs={12} sm={12}><h4>รายละเอียดความเสียหาย</h4></Grid>
                {
                  caseData?.damage_detail?
                  <Grid item xs={12} sm={12}>
                      <TextField
                          fullWidth
                          multiline
                          minRows={4}
                          maxRows={4} // over max rows has scrollbar
                          InputLabelProps={{ shrink: true }}
                          value={(caseData?.damage_detail?caseData.damage_detail:"")}
                      />
                  </Grid>
                  : <>
                  <Grid item xs={4} sm={4}></Grid>
                  <Grid item xs={4} sm={4}>
                      <FormLabel>ไม่มีความเสียหาย</FormLabel>
                  </Grid>
                  <Grid item xs={4} sm={4}></Grid>
                  </>
                }
                

              <Grid item xs={12} sm={12}><h4>อุปกรณ์ตกแต่ง</h4></Grid>

                <Grid item xs={6} sm={3}><FormLabel >ยางอะไหล่</FormLabel></Grid>
                <Grid item xs={6} sm={9}>
                    <FormLabel >
                        {caseData?.spareTireIsExist?caseData.spareTireIsExist:"ไม่มี"}
                    </FormLabel>
                </Grid>
                
                <Grid item xs={6} sm={3}><FormLabel >กล้องหน้ารถ</FormLabel></Grid>
                <Grid item xs={6} sm={9}>
                    <FormLabel >
                        {caseData?.carCAMIsExist?caseData.carCAMIsExist:"ไม่มี"}
                    </FormLabel>
                </Grid>
                
                <Grid item xs={6} sm={3}>
                    <FormLabel >ล้อแม็ก</FormLabel>
                </Grid>
                <Grid item xs={6} sm={9}>
                    <FormLabel >
                        {caseData?.maxWheelIsExist?caseData.maxWheelIsExist:"ไม่มี"}
                    </FormLabel>
                </Grid>
                
                
              <Grid item xs={12} sm={12}><h4>เอกสาร</h4></Grid>
                <Grid item xs={6} sm={3}>
                    <FormLabel >เล่มทะเบียนรถ</FormLabel>
                </Grid>
                <Grid item xs={6} sm={9}>
                    <FormLabel >
                        {caseData?.carBookIsExist?caseData.carBookIsExist:"ไม่มี"}
                    </FormLabel>
                </Grid>

                
                <Grid item xs={6} sm={3}>
                    <FormLabel >เลขตัวถัง</FormLabel>
                </Grid>
                <Grid item xs={6} sm={9}>
                    <FormLabel >
                        {caseData?.carChassisIsExist?caseData.carChassisIsExist:"ไม่มี"}
                    </FormLabel>
                </Grid>
                
                
              {/*
              <Grid item xs={12} sm={12}><h4>รายละเอียดเพิ่มเติม</h4></Grid>
                <Grid item xs={12} sm={12}>
                    <FormLabel >- ความเสียหายเบื้องต้น ที่เกิดขึ้นก่อนการทำประกันภัย ซึ่งบริษัทฯ จะไม่รับผิดชอบการต่อความเสียหายดังกล่าว หากผู้เอาประกันจะต้องจัดซ่อมเสร็จสิ้น พร้อมทั้งนำรถมาตรวจสภาพใหม่อีกครั้ง ฉะนั้นหากมีอุบัติเหตุและมีความเสียหายเพิ่มเติมจากความเสียหายที่ตรวจพบแล้ว บริษัทฯ จะไม่รับผิดชอบค่าเสียหายในส่วนที่เกินจากที่ประเมินไว้เท่านั้น</FormLabel>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormLabel >- บันทีกการตรวจสภาพนี้ถือเป็นส่วนหนึ่งของสัญญารับประกันได้ตกลงจัดทำกับบริษัทฯ ซึ่งผู้เอาประกันได้อ่านและตกลงยอมรับตามเงื่อนไขข้างต้นแล้ว</FormLabel>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormLabel >- บริษัทฯ รวบรวมข้อมูลเพื่อใช้ในการทำประกันภัย โดยบริษัทจะไม่นำข้อมูลส่วนตัวของท่าน (อาทิเช่น ชื่อ-สกุล หมายเลขโทรศัพท์มือถือ เลขบัตรประชาชน) ไปเผยแพร่ในวัตถุประสงค์อื่นใด และท่านจะได้รับความคุ้มครองตาม พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562</FormLabel>
                </Grid>
              */}


            </Grid>
        </React.Fragment>
      }

    </div>
  );
}
 
export default App;